import { render, staticRenderFns } from "./userReg.vue?vue&type=template&id=395de716&scoped=true&"
import script from "./userReg.vue?vue&type=script&lang=js&"
export * from "./userReg.vue?vue&type=script&lang=js&"
import style0 from "./userReg.vue?vue&type=style&index=0&id=395de716&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395de716",
  null
  
)

export default component.exports